<template>
  <div class="table">
    <el-dialog v-loading.lock="loading"
               title="用户自定义列"
               :visible.sync=show
               @close="closeShow()">

      <draggable class="draggable" :list="tableData" :move="getdata" @update="datadragEnd">
        <transition-group name="list-complete">
          <sort-item ref="sortColumn" v-for="element in tableData" :key="element.name" :row="element"
                     class="list-complete-item"></sort-item>
        </transition-group>
      </draggable>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="restore">恢复默认</el-button>
        <el-button @click="closeShow">取消</el-button>
        <el-button type="primary" :loading="locked" @click="onSumbit">保存</el-button>
      </span>

    </el-dialog>
  </div>
</template>

<script>
  import listMixins from '@/mixins/list'
  import draggable from 'vuedraggable'
  import sortItem from '../column/sortItem'
  import store from "@/store/index";

  export default {
    components: {
      draggable,
      'sort-item': sortItem,
    },
    // 使用混合
    mixins: [listMixins],
    data() {
      return {
        //模态框组件处于关闭状态
        show: false,
        locked: false,
        loading: false,
        searchForm: {},
        tableData: [],
        parentId: '',
        form: {
          id: '',
          name: '',
          oldName: '',
          code: '',
          title: '',
          label: '',
          width: '',
          oldWidth: '',
          align: '',
          userName: '',
          required: '',
          isShow: '',
          groupId: '',
        },
        // 以下为table相关
        params: {
          page: 1,
          pageSize: 20000,
          orderBy: "id desc",
          totalRows: 0,
          export: false,
          //查询条件
          queryParamList: [
            {field: "name", type: "string", logic: "like", value: '', items: []},
            {field: "parentId", type: "string", logic: "=", value: '', items: []},
          ]
        },

        // 自定义表格栏目
        columnsSchema: {},
      }
    },

    methods: {

      getdata: function (evt) {
        console.log(evt.draggedContext.element.id)
      },
      datadragEnd: function (evt) {
        console.log('拖动前的索引：' + evt.oldIndex);
        console.log('拖动后的索引：' + evt.newIndex);
      },

      restore() {
        this.$fetchData(this.$api.fwUserColumn.restore, {}, 'get').then(res => {
          store.dispatch('getFwCols').then(r => { })
          this.loading = false;
        }).catch(err => {
          this.$message.error(`恢复默认失败：${err}`)
        }).finally(e => {
          this.locked = false
        });
        this.closeShow();
      },

      // 提交保存
      onSumbit() {
        //验证用户自定义的width（调用子组件selfCloumn）
        let allSort =null;
          this.$nextTick(()=>{
            allSort = this.$refs.sortColumn;
            allSort.forEach((row, index,isNumber) => {
            // console.log(isNumber,'isNumber');
            if (!isNumber) {
              this.$message.error("宽度必须是数字或者auto!");
              return;
            }
          });
        });

        this.locked = true;
        this.tableData.forEach((item, index) => {
          item.orderId = index;
          //根据页面勾选修改对象的isShow数值
          if (item.isShow == true) {
            item.isShow = 1;
          } else if (item.isShow == false) {
            item.isShow = 0;
          }
          //对齐方式
          if (item.align == "居中") {
            item.align = 'center';
          } else if (item.align == "靠右") {
            item.align = 'right';
          } else if (item.align == "靠左") {
            item.align = 'left';
          }
        });
        console.log(this.tableData);
        this.$fetchData(this.$api.fwUserColumn.setColumn, this.tableData, 'post').then(res => {
          //获取自定义列
          store.dispatch('getFwCols').then(r => { })
          this.loading = false;
          this.show = false;
        }).catch(err => {
          this.$message.error(`保存失败：${err}`)
          this.show = false;
        }).finally(e => {
          this.locked = false
          this.show = false;
        });
        // this.closeShow();
      },

      closeShow() {
        this.show = false;
      },

      // //table表格的数据选择条数的集合
      // handleSelectionChange(val) {
      //   this.multipleSelection = val;
      // },

      loadInitData() {
        console.log('loadInitData');
        this.show = true;
        //使用 全局变量parentId 作为中间变量以缓存
        this.parentId = this.$route.query.id;
        //清除页面缓存
        localStorage.removeItem("querypage" + this.$route.path + Base64.encode(this.$route.query));
        this.$fetchData(this.$api.fwUserColumn.getColumn, {}, 'get').then(res => {
          // this.$fetchData(this.$api.fwUserColumn.getCustom, {}, 'get').then(res => {
          // then 指成功之后的回调 (注意：使用箭头函数，可以不考虑this指向)
          //数据动态加载进表格中
          this.tableData = res;
          this.$nextTick(() => {
            this.tableData.forEach((row, index) => {
              if (row.width == null || row.width == 'null') {
                row.width = 'auto';
              }
              row.orderId = index;
              row.builtIn = 0;
              if (row.isShow == '1' || row.required == '1') {
                row.isShow = true;
              } else {
                row.isShow = false;
              }
              if (row.align == "center") {
                row.align = '居中';
              } else if (row.align == "right") {
                row.align = '靠右';
              } else if (row.align == "left") {
                row.align = '靠左';
              }
              // if (row.isShow == '1') {
              //   this.$refs.multipleTable.toggleRowSelection(row, true);
              // }
            });
          })
        }).catch((error) => {
          // catch 指请求出错的处理
          console.log(error);
        });

      },

      //刷新
      refresh() {
        this.show = true;
        this.loadInitData();
      },

    },

    // // 加载数据
    // created() {
    //   //使用 全局变量parentId 作为中间变量以缓存
    //   this.show = true;
    //   this.parentId = this.$route.query.id;
    //   //清除页面缓存
    //   localStorage.removeItem("querypage" + this.$route.path + Base64.encode(this.$route.query));
    //   this.loadInitData();
    // },

  }
</script>

